import {
    FETCH_ADAPTIVE_PLAN_CALENDAR,
    FETCH_ADAPTIVE_PLAN_CALENDAR_SUCCESS,
    FETCH_ADAPTIVE_PLAN_CALENDAR_ERROR,
    FETCHING_ADAPTIVE_PLAN_CALENDAR
} from '../../actions/ActionTypes.js';

const RESET = 'RESET';

const INITIAL_STATE = {
    fetching: false,
    error: false,
    hasFetched: false,
    entity: {}
};

const fetchingAdaptivePlanCalendar = (state, action) => {
    return {
        fetching: true,
        error: false,
        hasFetched: false,
        entity: {}
    };
};

const receiveAdaptivePlanCalendar = (state, action) => {
    return {
        fetching: false,
        error: false,
        hasFetched: true,
        entity: {
            ...action.atpCalendar
        }
    };
};

const receiveAdaptivePlanCalendarError = (state, action) => {
    return {
        fetching: false,
        error: true,
        entity: {}
    };
};

const reset = (state) => {
    return INITIAL_STATE;
};

const handlers = {
    [FETCHING_ADAPTIVE_PLAN_CALENDAR]: fetchingAdaptivePlanCalendar,
    [FETCH_ADAPTIVE_PLAN_CALENDAR_SUCCESS]: receiveAdaptivePlanCalendar,
    [FETCH_ADAPTIVE_PLAN_CALENDAR_ERROR]: receiveAdaptivePlanCalendarError,
    [RESET]: reset
};

export const getATPCalendar = (state) => state.atpCalendar.entity;
export const isATPCalendarError = (state) => state.atpCalendar.error;
export const hasCalendarFetched = (state) => {
    return state.atpCalendar.hasFetched;
};
export const isFetchingCalendar = (state) => state.atpCalendar.fetching;

export default function atpCalendar(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchAdaptivePlanCalendar(athletePlanId, startDate, endDate, lang) {
    return {
        type: FETCH_ADAPTIVE_PLAN_CALENDAR,
        payload: {
            athletePlanId,
            startDate,
            endDate,
            lang
        }
    };
}

export function resetPlanCalendar() {
    return {
        type: RESET
    };
}
